export const MAX_RECORDING_TIME = 2

export const recorderError = {
  RECORDER_ERROR: 'Error on Recorder',
  NOT_ALLOWED: 'Request is not allowed by the user agent',
}

export const recorderStatus = {
  IDLE: 'idle',
  BLOCKED: 'blocked',
  RECORDING: 'recording',
  STOPPING: 'stopping',
  STOPPED: 'stopped',
  SAVING: 'saving',
}

export const platform = {
  ANDROID: 'android',
  IOS: 'ios',
  MAC: 'macos',
  WIN: 'windows',
}

export const browser = {
  CHROME: 'Chrome',
  EDGE: 'Microsoft Edge',
  FIREFOX: 'Firefox',
  SAFARI: 'Safari',
}
